module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARRJREFUeNrs1MERREAQQFGjBCIUIrGhEcmuTGQyOoQ9mD6M96qUW9N8hgEAAAAAAADoU2kxtNb6idOWukgpa+b1Ysdv8rs6Ysf96aFTo5ud41g6/3iy9ztbDB39BN9NAAJAAAgAASAABIAAEAACQAAIAAEgAASAABAAAkAACAABIAAEgAAQAAJAAAgAASAABIAAEAACQAAIAAEgAASAABAAAkAACAABIAAEgAAQAAJAAAgAASAABIAAEAACQAAIAAEgAASAABAAAkAACAABIAAEgAAQAAJAAAgAASAABIAAEAACQAAIAAEgAAQgAASAABAAAkAACAABIADeYGo094rj1/mzy97vkisAAAAAAADwv1uAAQDEAw5ttMivggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icons/videoplayer/pause-128x128-white.png
// module id = PR57
// module chunks = 1